import { isEmpty } from '../utils/bits'
import { isFunction } from 'lodash-es'

import {
  signFallbackToEnv,
  signFallbackToKey,
  signFallbackToConst
} from './gallery-properties.flow'

export function FallbackToMessageBundle(mbKey) {
  return FallbackToKey(getMessageBundleKey)

  function getMessageBundleKey(_rawVal, calcProp) {
    const complete_message_bundle = calcProp('complete_message_bundle')
    const fallbackVal = complete_message_bundle[mbKey]
    return fallbackVal
  }
}

export function FallbackToKey(...getKeys) {
  return signFallbackToKey(Fallback(true, getKeys))
}

export function FallbackToEnv(...getEnvs) {
  return signFallbackToEnv(Fallback(false, getEnvs))
}

export function FallbackToConst(...getConstants) {
  return signFallbackToConst(Fallback(false, getConstants))
}

export function Fallback(useCalcProp, getFallbacks) {
  return fallback

  function fallback(rawVal, calcProp) {
    if (!isEmpty(rawVal)) {
      return rawVal
    }

    for (const getFallback of getFallbacks) {
      const fallbackVal = isFunction(getFallback)
        ? getFallback(rawVal, calcProp)
        : useCalcProp
          ? calcProp(getFallback)
          : getFallback

      if (!isEmpty(fallbackVal)) {
        return fallbackVal
      }
    }

    return null
  }
}
